import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files`;

export const downloadFile = async (fileId: number, filename: string): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = `${BASE_URL}/${fileId}`;

  const response = await axios.get<Blob>(finalURL, {
    headers: {
      'x-access-token': session?.accessToken,
    },
    responseType: 'blob',
    timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      typeof AbortSignal.timeout !== 'undefined'
        ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
        : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
  });

  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
